module.exports = __webpack_public_path__ + "img/5.7897972.78979721.png";